module.exports = __webpack_public_path__ + "img/lightBrown_attached.f674d521.svg";